import { NgModule } from '@angular/core';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';



@NgModule({
	imports: [
		BrowserAnimationsModule,
		MatDatepickerModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatInputModule,
		MatNativeDateModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatButtonToggleModule,
		MatButtonModule,
		MatAutocompleteModule,
		MatProgressBarModule,
		MatSelectModule,
		DragDropModule,
		MatTooltipModule,
		MatMenuModule,
		MatDividerModule,
		MatTableModule,
		MatChipsModule
	],
	exports: [
		BrowserAnimationsModule,
		MatDatepickerModule,
		MatExpansionModule,
		MatFormFieldModule,
		MatInputModule,
		MatNativeDateModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatButtonToggleModule,
		MatButtonModule,
		MatAutocompleteModule,
		MatProgressBarModule,
		MatSelectModule,
		DragDropModule,
		OverlayModule,
		MatTooltipModule,
		MatMenuModule,
		MatDividerModule,
		MatTableModule,
		MatChipsModule
	]
})
export class MaterialModule { }
